import { useEffect, useState } from 'react';

export const TEMA = {
  bg: '#14161A',
  bgPanel: '#1B1D22',
  bgSidebar: '#0E1013',
  border: '#2A2B2E',
  ink: '#F0EEE8',
  inkSoft: '#9B9A93',
  inkFaint: '#6F6E68',
  accent: '#E0A83E',
  accentHover: '#F0BB56',
  onAccent: '#14161A',
  positive: '#5FAE8A',
};

const GOOGLE_FONTS_HREF =
  "https://fonts.googleapis.com/css2?family=Fraunces:ital,opsz,wght@0,9..144,400;0,9..144,500;0,9..144,600;1,9..144,400&family=Inter:wght@400;500;600&family=IBM+Plex+Mono:wght@400;500&display=swap";

// Laddar in Fraunces/Inter/IBM Plex Mono en gång per sidladdning.
// Anropas från varje sida/layout som använder temat, men lägger
// bara till <link>-taggarna första gången.
export function säkerställFonter() {
  if (document.getElementById('vinsales-fonter')) return;
  const preconnect1 = document.createElement('link');
  preconnect1.rel = 'preconnect';
  preconnect1.href = 'https://fonts.googleapis.com';
  const preconnect2 = document.createElement('link');
  preconnect2.rel = 'preconnect';
  preconnect2.href = 'https://fonts.gstatic.com';
  preconnect2.crossOrigin = 'anonymous';
  const stylesheet = document.createElement('link');
  stylesheet.id = 'vinsales-fonter';
  stylesheet.rel = 'stylesheet';
  stylesheet.href = GOOGLE_FONTS_HREF;
  document.head.append(preconnect1, preconnect2, stylesheet);
}

// Under den här bredden visas mobilversionen: meny i sidhuvudet, mindre
// marginaler och staplade rader i stället för kolumner.
export const MOBIL_BREDD = 768;

// matchMedia utgår från sidans bredd. window.innerWidth ändras på iPhone när
// man zoomar ut, och då växlade appen felaktigt till datorvyn.
const MOBIL_FRÅGA = `(max-width: ${MOBIL_BREDD - 1}px)`;

export function useMobil(): boolean {
  const [mobil, setMobil] = useState(() => window.matchMedia(MOBIL_FRÅGA).matches);
  useEffect(() => {
    const mq = window.matchMedia(MOBIL_FRÅGA);
    const vidÄndring = () => setMobil(mq.matches);
    vidÄndring();
    mq.addEventListener('change', vidÄndring);
    return () => mq.removeEventListener('change', vidÄndring);
  }, []);
  return mobil;
}
